import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from '../../../Utils';
import { connect, actions } from '../../../Store';
import BaseMarketingLayout from '../BaseList';
import VideoCard from '../../ProductCatalog/Components/VideoCard';
import API2 from '../../../API2';

const ListOfProducts = styled.div`
  padding: ${rem(10)};
  padding-right: ${rem(20)};
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${rem(500)}, auto));
  grid-gap: 0rem;
`;

class Graphic extends BaseMarketingLayout {
  constructor(props) {
    super(props);
    this.pageSizes = [60, 90, 120];
    this.defaultLimit = 60;
    this.state = {
      ...this.state,
      title: __('Videá'),
      limit: 60,
      maxFilterWidth: 140,
      showFilter: this.props.productId ? false : true,
      showHeader: this.props.productId ? false : true,
      showPerSite: this.props.productId ? false : true,
      notFoundMessage: __(
        'Ľutujeme, vyhľadávaniu nezodpovedajú žiadne výsledky ',
      ),
      isProduct: false,
      defaultFilter: [
        {
          id: 'type',
          values: ['videa'],
        },
      ],
    };

    actions.setActiveMenuItem('84');
  }

  componentDidMount() {
    const {
      actualPage,
      checkedFilter,
      offset,
      nextOffset,
      total,
    } = this.loadActualData();
    let newCheckedFilter =
      checkedFilter && checkedFilter !== 'undefined'
        ? JSON.parse(checkedFilter)
        : [];

    if (!newCheckedFilter || newCheckedFilter.length === 0) {
      newCheckedFilter = this.state.defaultFilter;
    }

    this.setState(
      {
        actualPage:
          actualPage &&
          actualPage !== null &&
          actualPage !== 'null' &&
          actualPage > 0
            ? Number(actualPage)
            : 1,
        offset:
          offset && offset !== null && offset !== 'null' && offset > 0
            ? Number(offset)
            : 0,
        nextOffset:
          nextOffset &&
          nextOffset !== null &&
          nextOffset !== 'null' &&
          nextOffset > 0
            ? Number(nextOffset)
            : 0,
        total:
          total && total !== null && total !== 'null' && total > 0
            ? Number(total)
            : 0,
        checkedFilter: [...newCheckedFilter],
      },
      async () => {
        await this.fetchFilter(false);
        this.fetchData({
          offset:
            offset && offset !== null && offset !== 'null' && offset > 0
              ? Number(offset)
              : 0,
          total,
        });
        this.saveActualData(1, 0, null, [], null);
      },
    );
  }

  async fetchData(parameters = {}) {
    const { limit, checkedFilter, searchText } = this.state;
    const { productId } = this.props;

    try {
      const params = parameters;

      if (checkedFilter) {
        params.filters = {};
        const str = JSON.stringify({ filter: checkedFilter });
        params.filters = str;
      }

      if (!checkedFilter.find(c => c.id === 'type')) {
        checkedFilter.concat(this.state.defaultFilter);
      }

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      params.type = 'video';

      const newData = await API2.getB2BMultimediaAction(
        Object.assign(params, { limit, productId }),
      );

      this.setState({
        items: newData.multimedia,
        loading: false,
        filtersDisabled: false,
        limit: newData.limit,
        offset: newData.offset,
        total: newData.total,
        nextOffset: newData.next_offset,
      });
    } catch (e) {
      this.setState({
        notFoundMessage: __('Pri načítaní dát sa vyskytla chyba'),
        loading: false,
      });
    }
  }

  showImageDetail(fullPath) {
    this.setState({
      imageDetailFullPath: fullPath,
    });
  }

  renderItemsList() {
    const { items } = this.state;
    return (
      <ListOfProducts>
        {items.map(p => {
          return (
            <VideoCard
              history={this.props.history}
              key={p._id}
              data={p}
              appLang={this.props.appLang}
            />
          );
        })}
      </ListOfProducts>
    );
  }

  render() {
    return super.render();
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Graphic);



// WEBPACK FOOTER //
// ./src/Containers/Marketing/Videos/index.jsx